import { c as _c } from "react/compiler-runtime";
import { EmptyState as ChakraEmptyState, VStack } from '@chakra-ui/react';
import * as React from 'react';
export interface EmptyStateProps extends ChakraEmptyState.RootProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
}
export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(function EmptyState(props, ref) {
  const $ = _c(19);
  let children;
  let description;
  let icon;
  let rest;
  let title;
  if ($[0] !== props) {
    ({
      title,
      description,
      icon,
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = description;
    $[3] = icon;
    $[4] = rest;
    $[5] = title;
  } else {
    children = $[1];
    description = $[2];
    icon = $[3];
    rest = $[4];
    title = $[5];
  }
  let t0;
  if ($[6] !== icon) {
    t0 = icon && <ChakraEmptyState.Indicator>{icon}</ChakraEmptyState.Indicator>;
    $[6] = icon;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  let t1;
  if ($[8] !== description || $[9] !== title) {
    t1 = description ? <VStack textAlign="center"><ChakraEmptyState.Title>{title}</ChakraEmptyState.Title><ChakraEmptyState.Description>{description}</ChakraEmptyState.Description></VStack> : <ChakraEmptyState.Title>{title}</ChakraEmptyState.Title>;
    $[8] = description;
    $[9] = title;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== children || $[12] !== t0 || $[13] !== t1) {
    t2 = <ChakraEmptyState.Content>{t0}{t1}{children}</ChakraEmptyState.Content>;
    $[11] = children;
    $[12] = t0;
    $[13] = t1;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== ref || $[16] !== rest || $[17] !== t2) {
    t3 = <ChakraEmptyState.Root ref={ref} {...rest}>{t2}</ChakraEmptyState.Root>;
    $[15] = ref;
    $[16] = rest;
    $[17] = t2;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  return t3;
});